<script setup lang="ts">
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons'
import { faOctagonXmark } from '@fortawesome/pro-solid-svg-icons'

withDefaults(defineProps<{
  type?: InputType
  inputmode?: 'text' | 'numeric' | 'decimal' | 'tel' | 'email' | 'url' | 'search' | 'none'
  label: string
  id: string
  required?: boolean
  disabled?: boolean
  placeholder?: string
  name?: string
}>(), {
  type: 'text',
  required: false,
  disabled: false,
  placeholder: '',
})

defineEmits(['input'])

const inputRef = useTemplateRef<HTMLInputElement>('input')

defineExpose({ inputRef })

const model = defineModel<string | number>({ default: '' })

const error = defineModel<string | boolean>('error', { default: false })

const showPassword = ref<boolean>(false)

function togglePassword() {
  showPassword.value = !showPassword.value
}

function clearInput() {
  model.value = ''
  error.value = false
}
</script>

<template>
  <div class="relative flex flex-col flex-wrap gap-y-2xs justify-start">
    <label :for="id" :class="inputVariants.label()">
      <span>
        {{ label }}
        <span v-if="required" class="text-red-500">*</span>
      </span>
      <input
        :id="id"
        ref="input"
        v-model="model"
        :type="showPassword ? 'text' : type"
        :required="required"
        :disabled="disabled"
        :placeholder="placeholder"
        :inputmode="inputmode"
        :name="name || id"
        :class="inputVariants.base({ error: !!error })"
        @input="$emit('input', $event)"
      >
    </label>
    <Button v-if="!disabled && error" class="!text-red-500 absolute top-[2rem] right-2 !bg-transparent !p-0" :icon="faOctagonXmark" @click="clearInput" />
    <Button v-else-if="type === 'password'" class="!text-blurple-500 absolute top-[2rem] right-2 !bg-transparent !p-0" :icon="showPassword ? faEye : faEyeSlash" :disabled="disabled" :class="{ 'hover:!text-blurple-300': !disabled }" @click="togglePassword" />
    <FormInputError v-if="error && typeof error === 'string'">
      {{ error }}
    </FormInputError>
    <slot />
  </div>
</template>
